import React, { Dispatch, ReactNode, SetStateAction } from 'react';

import cn from 'classnames';
import { observer } from 'mobx-react';

import WebsocketKline from '@components/WebsocketKline';
import { Select, Tabs } from '@element/index';
import { store } from '@store/index';
import I18n from '@utils/i18n';
import TradeList from '@widget/market/TradeList/List';
import { useMain } from '@widget/trade';

import styles from './index.module.less';

interface SpotListProps {
  currency: string | number
  selectOptions: {value: string, label: ReactNode }[]
  loading: boolean
  dataList: Record<string, any>[]
  zoneData: {categoryName: string, categoryKey: string }[]
  tabsChange: (key: string) => void
  setCurrency: Dispatch<SetStateAction<string | number>>,
  zone: string
}

export const SpotList: React.FC<SpotListProps> = observer((props) => {
  const {
    currency,
    selectOptions,
    loading,
    dataList,
    zoneData,
    tabsChange,
    setCurrency,
    zone
  } = props
  const { tradeStore, marketStore } = store;

  const params = useMain({ marketStore, tradeStore });
  const { onWebSocketReady } = params;
  console.log(dataList, 'dataList555')
  return (
    <div>
      <WebsocketKline onReady={onWebSocketReady} />
      <div className={cn(styles.container, 'zonesTab')}>
        <div className={styles.selectBox}>
          <Select
            selectBtnCalssName={styles.selectClass}
            options={selectOptions}
            onChange={(e) => setCurrency(e.value)}
            value={currency}
          />
        </div>

        <Tabs
          className={styles.moreTabsClass}
          onChange={tabsChange}
          activeKey={zone}
          items={zoneData.map((item, index) => {
            return {
              label: (
                <span className={cn(styles.tabsLabel, 'DINPro')}
                  data-buried={`web_market_markets_spot_sectortype_select_${item.categoryKey}`}>
                  {/* {item.categoryName} */}
                  {index > 0 ? I18n.t(`zoneName${item.categoryKey.toUpperCase()}`) : item.categoryName}
                </span>
              ),
              key: item.categoryKey
            };
          })}
        />
      </div>
          <TradeList
            dataSource={dataList}
            loading={loading}
          />
    </div>
  );
});
